// @flow
export { default } from './BrandPlaceholder';



// WEBPACK FOOTER //
// ./src/components/brand/BrandPlaceholder/index.js